import { useMemo } from 'react';

import { useChat } from '@/features/ai-chat/state/useChat';
import type { HumanMessage } from '@/features/ai-chat/types/chat.types';
import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';

export function useHumanMessage(msg: HumanMessage) {
  const promptShareEnabled = useFlag(FeatureFlag.AiPromptShareEnabled);
  const { animatedHumanId, animatedText, onAnimatedComplete } = useChat();

  const shouldAnimate = useMemo(
    () => animatedHumanId === msg.id && !!animatedText,
    [animatedHumanId, animatedText, msg.id]
  );

  return { promptShareEnabled, animatedText, onAnimatedComplete, shouldAnimate } as const;
}
